import classNames from 'classnames/bind';
import { DurationMap } from 'common/types';
import { useSearchParamsContext } from 'contexts/searchParams';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  className?: string;
  clickCodePrefix: string;
  onClick(): void;
}

export default function StayDuration({
  className,
  clickCodePrefix,
  onClick,
}: IProps) {
  const {
    searchParams: { stayLength },
  } = useSearchParamsContext();
  const duration = stayLength ? DurationMap.get(stayLength) : null;

  return (
    <button
      type="button"
      className={cx(className, {
        Date: true,
      })}
      aria-selected={!!duration}
      data-event-nlog="click"
      data-event-area-code={`${clickCodePrefix}.depdate1`}
      onClick={onClick}
    >
      {duration}
    </button>
  );
}
